export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_02.2a720b18.mp4";